export default {
  ARG_LENGTH_ERROR(funName, needLen, currentLen, isAbsolute = true) {
    throw new Error(`函数"${funName}"${isAbsolute ? '' : '至少'}需要${needLen}个参数，但当前只有${currentLen}个`)
  },

  DATA_TYPE_ERROR(funName, index, needType, currentType) {
    throw new Error(`函数"${funName}"第${index}个参数必须是${needType}，现在是${currentType}`)
  }
}